'use client';

import * as React from 'react';
import { useCharts } from "../../internals/store/useCharts.js";
import { ChartContext } from "./ChartContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
function ChartProvider(props) {
  const {
    children
  } = props;
  const {
    contextValue
  } = useCharts([], {});
  return /*#__PURE__*/_jsx(ChartContext.Provider, {
    value: contextValue,
    children: children
  });
}
export { ChartProvider };